import { companyTypesForUserRole } from './config/companyTypesForUserRole';

function companyTypeAccessHandler(companyType, userType) {
  return (
    companyTypesForUserRole[userType] && companyTypesForUserRole[userType].includes(companyType)
  );
}

export { companyTypeAccessHandler };
